import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { AssessmentSubmissionParams, AssessmentSubmissionResponse, UUID } from "@/core/types";
import { removeTaskFromProfile } from "@/redux/actions/auth";
import { showToast } from "@/providers/ToastProvider";
import type { ToastConfig } from "@/ui2/molecules/Toast";

import { postAnswer } from "../queryFunctions/postAnswer";

type UseSubmitAssessmentOptions = {
  taskId: UUID;
  toastConfig: ToastConfig;
} & UseMutationOptions<AssessmentSubmissionResponse, unknown, AssessmentSubmissionParams>;

export function useSubmitAssessment({
  onSuccess,
  taskId,
  toastConfig,
  ...options
}: UseSubmitAssessmentOptions) {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: postAnswer,
    ...options,
    onSuccess: async (data, variables, context) => {
      // Optimistically remove task from profile
      dispatch(removeTaskFromProfile(taskId));

      showToast([
        {
          heading: toastConfig.heading,
          text: toastConfig.text,
          variant: "success",
        },
      ]);

      onSuccess?.(data, variables, context);
    },
  });
}
